import _jsx from "@babel/runtime/helpers/jsx";
import React, { memo, useEffect, useCallback } from 'react';
import { deprecate } from 'react-is-deprecated';
import PropTypes from 'prop-types';
import { withFormsy } from 'formsy-react';
import MaskedTextInput, { conformToMask } from 'react-text-mask';
import clsx from 'clsx';
import { Input as ReaxlInput } from 'reaxl';
import { createChainedFunction } from '@atc/create-chained-function';
import CommonFormComponent from '../hocs/CommonFormComponent';
import cleanFormProps from '../cleanFormProps';
function Input(_ref) {
  let {
    className,
    disabled,
    formElementProps = {},
    id,
    isFlat,
    // deprecated
    isFormDisabled,
    isPristine,
    isValidValue,
    mask,
    onBlur,
    onKeyDown,
    onChange,
    setValue,
    setState,
    type = 'text',
    validateOn = 'blur',
    value = '',
    wrapperProps = {},
    ...rest
  } = _ref;
  useEffect(() => {
    if (value && mask?.length > 0) {
      try {
        const {
          conformedValue = ''
        } = conformToMask(value.toString(), mask) || {};
        if (value !== conformedValue) {
          setValue(conformedValue);
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleChange = useCallback(event => {
    switch (validateOn) {
      case 'blur':
        setValue(event.currentTarget.value, !isPristine);
        break;
      case 'change':
        setValue(event.currentTarget.value);
        break;
      default:
    }
  }, [setValue, validateOn, isPristine]);
  const handleBlur = event => {
    const curValue = event.currentTarget.value;
    if (validateOn === 'blur' && isPristine) {
      setValue(curValue);
    }
    event.currentTarget.setAttribute('isvalid', isValidValue(curValue));
  };
  const handleKeyDown = event => {
    if (event.keyCode === 13) {
      setValue(event.currentTarget.value);
    }
  };
  const renderElement = () => {
    const componentProps = ['attachToForm', 'detachFromForm', 'displayName', 'errorMessage', 'forwardedRef', 'hasValue', 'isFlat', 'isRequired', 'innerRef', 'isFormSubmitted', 'isValidValue', 'isValid', 'resetValue', 'rootClasses', 'runValidation', 'setValidations', 'showRequired', 'showError', 'validations', 'validate'];
    const cleanedProps = cleanFormProps(rest, componentProps);
    const elementClasses = clsx({
      [className]: className,
      'form-control': type !== 'range'
    });
    const elementProps = {
      ...cleanedProps,
      ...formElementProps,
      className: elementClasses,
      id,
      mask,
      value,
      onBlur: createChainedFunction(handleBlur, onBlur),
      onKeyDown: createChainedFunction(handleKeyDown, onKeyDown),
      onChange: createChainedFunction(handleChange, onChange),
      disabled: isFormDisabled || disabled,
      component: mask ? MaskedTextInput : 'input',
      type
    };
    return /*#__PURE__*/React.createElement(ReaxlInput, elementProps);
  };

  // when form is flat, hide input container and only display the value
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", Object.assign({
    className: clsx({
      hidden: isFlat
    })
  }, wrapperProps), renderElement()), isFlat && /*#__PURE__*/_jsx("div", {}, void 0, value));
}
export default /* #__PURE__ */withFormsy(/* #__PURE__ */CommonFormComponent(/*#__PURE__*/memo(Input)));